import React from 'react';
import PropTypes from 'prop-types';
import { ListGroup, ListGroupItem, Panel } from 'react-bootstrap';
import GroupByCodeTreeItem from './GroupByCodeTreeItem.jsx';

const GroupByCodeTree = ({ filteredActivities, filteredActivitiesMap, activityCodesTree, datasetInfo }) => {
	if (!activityCodesTree || !Array.isArray(activityCodesTree.childrenSequence)) {
		return null;
	}

	const codeTree = [];
	for (let i = 0; i < activityCodesTree.childrenSequence.length; i++) {
		const t = activityCodesTree.childrenSequence[i];
		const codeItem = activityCodesTree.children[t];
		codeTree.push(
			<ListGroupItem key={t}>
				<GroupByCodeTreeItem
					codeItem={codeItem}
					filteredActivities={filteredActivities}
					filteredActivitiesMap={filteredActivitiesMap}
					datasetInfo={datasetInfo} />
			</ListGroupItem>
		);
	}

	return (
		<Panel
			defaultExpanded
			className="swaTree">
			<Panel.Heading>
				<Panel.Title toggle>{`Group By Activity Code ${activityCodesTree.name}`}</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				<ListGroup className="top-level">
					{codeTree}
				</ListGroup>
			</Panel.Collapse>
		</Panel>
	);
};

export default GroupByCodeTree;

GroupByCodeTree.propTypes = {
	filteredActivities: PropTypes.array,
	filteredActivitiesMap: PropTypes.object,
	activityCodesTree: PropTypes.object,
	datasetInfo: PropTypes.object
};
